"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sendMessageAndImmediatelyExecute = exports.process = exports.test = exports.read = exports.write = exports.voyageMessageId = void 0;
var assert_sidecar_1 = require("@lib/assert-sidecar");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var voyageMessageIds_1 = require("./voyageMessageIds");
var messageWriter_sidecar_1 = require("@engine/messageWriter-sidecar");
var websockets_sidecar_1 = require("@engine/websockets-sidecar");
exports.voyageMessageId = voyageMessageIds_1.EVoyageMessage.CrewHurtEnergy;
function write(m, d) {
    messageWriter_sidecar_1.messageWriter.write8(m, exports.voyageMessageId);
    messageWriter_sidecar_1.messageWriter.write32(m, d.crewId);
    messageWriter_sidecar_1.messageWriter.write16(m, d.newEnergyPoints);
}
exports.write = write;
function read(m) {
    var t = messageWriter_sidecar_1.messageWriter.read8(m);
    assert_sidecar_1.assert.eq(t, exports.voyageMessageId);
    var d = {
        crewId: messageWriter_sidecar_1.messageWriter.read32(m),
        newEnergyPoints: messageWriter_sidecar_1.messageWriter.read16(m),
    };
    return d;
}
exports.read = read;
function test() {
    var ex = {
        crewId: 100,
        newEnergyPoints: 55,
    };
    messageWriter_sidecar_1.messageWriter.test('crew-energy-hurt', ex, write, read);
}
exports.test = test;
function process(m) {
    var msg = read(m);
    diveCrew_sidecar_1.diveCrew.networkHurtEnergy(msg);
}
exports.process = process;
function sendMessageAndImmediatelyExecute(msg) {
    websockets_sidecar_1.websockets._sendMessageAndImmediatelyExecute(write, msg);
}
exports.sendMessageAndImmediatelyExecute = sendMessageAndImmediatelyExecute;
